import "./TabBar/style.css";

import { Link, useNavigate, useLocation } from "react-router-dom";
import coin from "../img/coin-svgrepo-com.svg";
import { useEffect, useRef } from "react";

const scroll = require("scroll");
const page = require("scroll-doc")();
const ease = require("ease-component");

const TabBar = ({ scrolling }) => {
  const [scrollTable, setScrollTable] = scrolling;

  const location = useLocation();
  const navigate = useNavigate();

  const animation = (index) => {
    for (
      var i = 0;
      i < document.getElementsByClassName("animationToTop").length;
      i++
    ) {
      if (i == index) {
        document.getElementsByClassName("animationToTop")[i].style.transform =
          "translateY(-15px)";
        document.getElementsByClassName("textTab")[i].style.opacity = "1";
      } else {
        document.getElementsByClassName("animationToTop")[i].style.transform =
          "translateY(0)";
        document.getElementsByClassName("textTab")[i].style.opacity = "0";
      }
    }
  };

  const scroller = (type) => {
    if (location.pathname !== "/") {
      navigate("/");
      setScrollTable(`${type}`);
    } else {
      setScrollTable(`${type}`);
    }
  };

  return (
    <div className="wrappertab">
      <div className="tabbar d-flex justify-content-between">
        <span
          onClick={() => {
            scroller("cur");
            animation(0);
          }}
        >
          <div className={`transformactive animationToTop`}>
            <i className="fa fa-usd icon-home"></i>
            <p
              className={`${
                location.pathname === "/" && !scrollTable ? "textactive" : null
              } textTab`}
            >
              ارز
            </p>
          </div>
        </span>

        <span
          onClick={() => {
            scroller("coin");
            animation(1);
          }}
          className="pl-0"
        >
          <div className="animationToTop">
            <img src={coin} style={{ fill: "white", width: "25px" }}></img>
            <p className="textTab">سکه</p>
          </div>
        </span>

        <span
          onClick={() => {
            if (location.pathname !== "/contact") {
              navigate("/contact");
            }
            animation(2);
          }}
          className="w-80"
        >
          <div className="animationToTop">
            <i className="fa fa-phone icon-home icon-home"></i>
            <p className="textTab">تماس با ما</p>
          </div>
        </span>
      </div>
    </div>
  );
};

export default TabBar;
